import { fetcher } from '@commenda/utils';
import { TNotificationChannel } from './types';

export async function updateNotificationPreference({
  topic,
  channel,
  enabled,
}: {
  topic: string;
  channel: TNotificationChannel;
  enabled: boolean;
}): Promise<void> {
  const response = await fetcher('notification-preferences', {
    method: 'POST',
    body: {
      topic,
      channel,
      status: enabled ? 'ENABLED' : 'DISABLED',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to update notification preference.');
  }
}
